import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {ProductType} from "../../../../../models/product/ProductType";
import {ProductName} from "../../../../../models/product/ProductName";
import {CapsuleIconComponent} from "./icon/CapsuleIconComponent";
import * as s from "./capsule.scss";
import {
    TextResizeableComponent
} from "../../../../components/global/text/resizeable/TextResizeableComponent";
import {Resources} from "../../../../../resources/Resources";
import {PermissionsService} from "../../../../../services/permissions/PermissionsService";
import {EntityService} from "../../../../../services/entity/EntityService";

export class CapsuleComponent extends Component {

    public productType: ProductType;
    public soon: boolean;

    constructor(type: ProductType, soon?: boolean) {
        super();
        this.productType = type;
        this.soon = soon ? soon : false;

        let style = "";
        switch (type) {
            case ProductType.SEDESTRAL:
                style = "width:46%;height:46%;";
                break;
        }

        //language=HTML
        this.template = `
            <div class="${s.componentCapsule} ${s[ProductName.toString(type)]}">
                <div style="${style}" class="${s.icon}">
                    ${this.draw(new CapsuleIconComponent(type))}
                </div>
            </div>
        `;
    }

    commit() {

        super.commit();
    }
}